import type {MouseEvent, CSSProperties} from 'react';

import type {SearchAssetInformationDto} from '../dto';

export interface ItemViewSubProps {
  handleItemClick: (
    event: MouseEvent<HTMLElement>,
    item: SearchAssetInformationDto,
  ) => void;
  onLoadMore: () => void;
}

export interface ItemTableRowProps {
  product: SearchAssetInformationDto;
  handleItemClick: (
    event: MouseEvent<HTMLElement>,
    item: SearchAssetInformationDto,
    loadMetadata?: boolean,
  ) => void;
  visibleColumns: Record<string, boolean>;
  style?: CSSProperties;
}

export interface ItemActionButtonsProps {
  product: SearchAssetInformationDto;
  reverseToggler: () => void;
}
export interface ItemCardProperties {
  product: SearchAssetInformationDto;
  handleItemClick: (
    event: MouseEvent<HTMLElement>,
    item: SearchAssetInformationDto,
  ) => void;
}
export interface StatusProperties {
  productStatus: string;
  trim?: boolean;
}
export interface ItemStatusProperties extends StatusProperties {
  id: string;
}

export interface ItemSelectionOptions {
  crtl: boolean;
  shift: boolean;
  dragEvent: boolean;
}
export interface ItemSelectionContextValue {
  selectedItems: SearchAssetInformationDto[];
  selectedItem: SearchAssetInformationDto | undefined;
  selectedItemIds: Set<string>;
  showSidebar: boolean;
  isSelected: (item: SearchAssetInformationDto) => boolean;
  changeSelectedItems: (
    selectedItem: SearchAssetInformationDto,
    itemSelectionOptions: ItemSelectionOptions,
  ) => void;
  closeSidebar: () => void;
}

export enum ItemStatusType {
  FREIGEGEBEN = 'freigegeben',
  NICHT_FREIGEGEBEN = 'nicht freigegeben',
  ABGELAUFEN = 'abgelaufen',
  AUTMATISCH = 'automatisch',
  FEHLER = 'Fehler',
  AUSSTEHEND = 'ausstehend',
}

export const ItemTypes = {
  IMAGE: 'image',
};
